// src/components/Modal/index.js
// Shared modal shell: dimmed backdrop, titled panel with an X button,
// Escape to close, background scroll lock, and focus restoration.
// Deliberately does NOT close on backdrop click — these wrap edit forms,
// and a stray click shouldn't throw away typed input.
import React, { useEffect, useRef } from 'react';
import './Modal.css';

const Modal = ({ title, onClose, children, maxWidth = 560 }) => {
  const panelRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKeyDown);
    panelRef.current?.focus();

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeyDown);
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    };
  }, [onClose]);

  return (
    <div className="app-modal-backdrop">
      <div
        className="app-modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={{ maxWidth }}
        ref={panelRef}
        tabIndex={-1}
      >
        <div className="app-modal-head">
          <h2 className="app-modal-title">{title}</h2>
          <button
            type="button"
            className="app-modal-close"
            aria-label="Close"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <div className="app-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
